import money from "../../../../assets/img/money.png";
import { useEffect, useState } from "react";
import { FinancialDTO } from "../../../../pages/financial/financial-DTO";
import { t } from "i18next";
import { formatCurrencyByLocale } from "../../../../utils/formatting";

interface Props {
  data: FinancialDTO[] | null;
  idTofilter: any;
}

export const CardDetailsfee: React.FC<Props> = ({ data, idTofilter }) => {
  const [filteredData, setFilteredData] = useState<any[]>([]);

  useEffect(() => {
    let tranlation = {
      d1: { value: 0, display: "one", color: "collect" },
      d2: { value: 1, display: "two", color: "Incoming" },
      d3: { value: 2, display: "three", color: "Received" },
    };
    if (data) {
   
      if (idTofilter?.label) {
        data = data.filter((obj) =>
          [idTofilter.label].includes(obj.scrapMaterialName)
        );
      }

      
      data.reduce((acc, obj) => {
        if (obj.status === "TO_COLLECT") {
          acc.d1.value += obj.valueFee || 0;
        } else if (obj.status === "TO_RECEIVE") {
          acc.d2.value += obj.valueFee || 0; 
        } else if (obj.status === "RECEIVED") {
          acc.d3.value += obj.valueFee || 0; 
        }
        return acc;
      }, tranlation);

    
      setFilteredData([tranlation.d1, tranlation.d2, tranlation.d3]);
    }
  }, [data, idTofilter]);

  return (
    <div>
      {filteredData.map((obj) => (
        <div className="detals-card" key={`${obj.label}-${obj.value}-${obj.status}`}> {/* Add a unique key prop here */}
          <div className={`icone ${obj.color}`}>.</div>
          <img src={money} alt="icon" className="img-icon" />
  
          <div className="second-card">
            <span>{t(`financial-dashboard.title-${obj.display}`)}</span>
            <span className="top">
              {formatCurrencyByLocale(obj.value, "pt-BR", "BRL")}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
